import { email } from './email.js'

const validation = {
  email,
}

export { validation }
